import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "runtimes"
    }}>{`Runtimes`}</h1>
    <p>{`Adobe I/O Runtime supports the three latest Node.js versions (see the `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/about/previous-releases#release-schedule"
      }}>{`Node.js release schedule`}</a>{` for details). We encourage you to always update your actions to the latest version in order to take advantage of latest security updates and the pre-warms feature, that dramatically improves cold-start times.`}</p>
    <p>{`The following npm modules are pre-installed (if your action uses any of these modules, you don`}{`’`}{`t have to package them together with action code):`}</p>
    <h3 {...{
      "id": "nodejs-v2260"
    }}>{`Node.js V22.6.0`}</h3>
    <pre><code parentName="pre" {...{}}>{`"express": "4.18.2",
"openwhisk": "3.21.7",
"body-parser": "1.20.2",
"redis": "4.6.9",
"node-fetch": "3.3.2",
"dnscache": "1.0.2",
"prom-client": "14.2.0"
`}</code></pre>
    <h3 {...{
      "id": "nodejs-v2070"
    }}>{`Node.js v20.7.0`}</h3>
    <pre><code parentName="pre" {...{}}>{`"express": "4.18.2",
"openwhisk": "3.21.7",
"body-parser": "1.20.2",
"redis": "4.6.9",
"node-fetch": "3.3.2",
"dnscache": "1.0.2",
"prom-client": "14.2.0"
`}</code></pre>
    <h3 {...{
      "id": "nodejs-v18142"
    }}>{`Node.js v18.14.2`}</h3>
    <pre><code parentName="pre" {...{}}>{`"express": "4.18.2",
"openwhisk": "3.21.7",
"body-parser": "1.20.2",
"redis": "4.6.5",
"node-fetch": "3.3.1",
"dnscache": "1.0.2",
"prom-client": "14.2.0"
`}</code></pre>
    <h3 {...{
      "id": "nodejs-v16170"
    }}>{`Node.js v16.17.0`}</h3>
    <pre><code parentName="pre" {...{}}>{`"express": "4.18.1",
"openwhisk": "3.21.6",
"body-parser": "1.20.0",
"redis": "4.1.0",
"node-fetch": "3.2.4",
"dnscache": "1.0.2",
"prom-client": "13.2.0"
`}</code></pre>
    <h3 {...{
      "id": "nodejs-v14200"
    }}>{`Node.js v14.20.0`}</h3>
    <pre><code parentName="pre" {...{}}>{`"express": "4.17.1",
"openwhisk": "3.21.6",
"body-parser": "1.19.0",
"cls-hooked": "4.2.2",
"redis": "3.1.2",
"node-fetch": "2.6.7",
"dnscache": "1.0.2",
"prom-client": "12.0.0"
`}</code></pre>
    <p>{`This is how you can specify explicitly a kind:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:action:create actionName fromFile.js --kind nodejs:20 
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:action:create actionName fromFile.js --kind nodejs:18 
`}</code></pre>
    <p>{`These images are on Docker Hub:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/adobeapiplatform/adobe-action-nodejs-v22/tags"
        }}>{`Node 22`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/adobeapiplatform/adobe-action-nodejs-v20/tags"
        }}>{`Node 20`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/adobeapiplatform/adobe-action-nodejs-v18/tags"
        }}>{`Node 18`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/adobeapiplatform/adobe-action-nodejs-v16/tags"
        }}>{`Node 16`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/adobeapiplatform/adobe-action-nodejs-v14/tags"
        }}>{`Node 14`}</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      